import { useState } from "react";
import { Mail, Send, Loader2, CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";
import { useAuth } from "@/hooks/useAuth";
import { useProfile } from "@/hooks/useProfile";

export function SupportSection() {
  const { user } = useAuth();
  const { data: profile } = useProfile();
  const { toast } = useToast();
  
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const handleSendEmail = () => {
    if (!message.trim()) {
      toast({
        variant: "destructive",
        title: "Erro",
        description: "Por favor, escreva uma mensagem.",
      });
      return;
    }

    setIsSending(true);

    // Build email body
    const userName = profile?.full_name || user?.email || "Usuário";
    const userEmail = user?.email || "Não informado";
    const emailSubject = subject.trim() || "Suporte FreelaDash";
    
    const emailBody = `
Nome: ${userName}
Email: ${userEmail}

Mensagem:
${message}
    `.trim();

    // Open mailto link
    const mailtoLink = `mailto:jmkoygg@gmail.com?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
    
    window.open(mailtoLink, '_blank');
    
    setIsSending(false);
    setIsSent(true);
    
    toast({
      title: "Email preparado!",
      description: "Seu aplicativo de email foi aberto com a mensagem pronta para envio.",
    });

    // Reset form after a delay
    setTimeout(() => {
      setSubject("");
      setMessage("");
      setIsSent(false);
    }, 3000);
  };

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        Precisa de ajuda? Envie uma mensagem para nossa equipe de suporte.
      </p>

      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="support-subject">Assunto</Label>
          <Input
            id="support-subject"
            placeholder="Ex: Dúvida sobre pagamentos"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            disabled={isSending}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="support-message">Mensagem</Label>
          <Textarea
            id="support-message"
            placeholder="Descreva sua dúvida ou problema..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={4}
            disabled={isSending}
            className="resize-none"
          />
        </div>

        <div className="flex items-center gap-4">
          <Button
            onClick={handleSendEmail}
            disabled={isSending || !message.trim()}
          >
            {isSending ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Preparando...
              </>
            ) : isSent ? (
              <>
                <CheckCircle className="h-4 w-4 mr-2" />
                Email preparado!
              </>
            ) : (
              <>
                <Send className="h-4 w-4 mr-2" />
                Enviar mensagem
              </>
            )}
          </Button>

          <a
            href="mailto:jmkoygg@gmail.com"
            className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-1"
          >
            <Mail className="h-4 w-4" />
            jmkoygg@gmail.com
          </a>
        </div>
      </div>
    </div>
  );
}
